import { CardActions } from '@mui/material';
import {
  DEMO_CLAIM,
  DEMO_CLAIM_SERVICES_SUCCESS,
  DEMO_CLAIM_SERVICES_FAIL,
  
  DEMO_CLAIM_ITEM_REMOVE,
  DEMO_CLAIM_ITEM_REMOVE_SUCCESS,

  DEMO_DEPENDANT_ADD,
  DEMO_DEPENDANT_REMOVE,

  DEMO_PATIENT_ADD,
  DEMO_PATIENT_REMOVE,

  DEMO_CLAIM_ITEM_ADD,
  DEMO_CLAIM_ITEM_ADD_SUCCESS,
  DEMO_CLAIM_ITEM_ADD_FAIL,

  DEMO_LOGIN_SUCCESS,
  DEMO_LOGIN_FAIL,

  DEMO_CLAIM_SUBMIT,
  DEMO_CLAIM_SUBMIT_FAIL,
  DEMO_CLAIM_SUBMIT_SUCCESS,

  DEMO_UPDATE_PERSONAL,

  DEMO_SET_FIELD,
  DEMO_MERGE_FIELD,

  DEMO_CLAIM_ITEM_CLEAR,

  DEMO_CLEAR
} from '../actions/types';

export const INITIAL_STATE = {
  user: {
    ID: '0000000',
    FIRST_NAME: 'Demo',
    LAST_NAME: 'Account',
    EMAIL: '',
    HUTK: '',
    EMPLOYER: '00000',
    BALANCE: 5000.00,
    PRODUCT: '',
    PROVINCE: '',
    EMPLOYEE_PAYS: 0.0,
    /*FUNDING_CODE: 4,
    ADMIN_FEE,
    GST,
    HST,
    RST,
    PST,
    PREM */
  },
  patients:{
    '0000000': {'FIRST_NAME': 'Demo', 'LAST_NAME': 'Account', 'DEPENDANT': '0000000' },
  },
  services: {
    1: {key: 1, SERVICE: 1, SERVICE_NAME:'Dental', REQUIREMENTS: null},
    2: {key: 2, SERVICE: 2, SERVICE_NAME:'Prescription Drugs', REQUIREMENTS: null},
  },
  claimItem: {

  },
  claimItems: [],
  dependants: [

  ],
  modalForm: {
    contentComponent: '',
    data:'',
    open: false
  },
  error: false,
  errors: {

  },
  submitMessage: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DEMO_SET_FIELD:
        return (action.datagroup !== '')?
        { ...state, [action.datagroup]: {...state[action.datagroup], [action.dataname]: action.datavalue }, error: false, errors: {}, loading: false }
        :
        { ...state, [action.dataname]: action.datavalue, error: false, loading: false };
    case DEMO_MERGE_FIELD:
      return (action.datagroup !== '')?
      { ...state, [action.datagroup]: {...state[action.datagroup], [action.dataname]:{ ...state[action.datagroup][action.dataname], ...action.datavalue } }, error: false, errors: {}, loading: false }
      :
      { ...state, [action.dataname]: { ...state[action.dataname], ...action.datavalue }, error: false, loading: false };
    case DEMO_LOGIN_FAIL:
      return { ...state, 
        error: true,
        errors: action.errors,
        loading: false
      }
    case DEMO_LOGIN_SUCCESS:
      return { ...state,
        services: action.data.services,
        user: {...state.user, ...action.data.user},
        error: false,
        errors: {},
        loading: false
      }
    case DEMO_CLAIM:
      return {
        ...INITIAL_STATE,
      };
    case DEMO_CLAIM_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.data.services,
        error: false,
        errors: {},
        loading: false
      }
    case DEMO_CLAIM_SERVICES_FAIL:
      return {
        ...state,
        error: false,
        errors: {},
        loading: false
      }
    case DEMO_UPDATE_PERSONAL:
      return {
        ...state,
        user: {...state.user, ...action.user},
        patients: {...state.patients, '0000000': { ...state.patients['0000000'], ...action.user} },
      }
    case DEMO_PATIENT_ADD:
      let id_max = 0;
      Object.values(state.patients).forEach(
        (patient) => { 
          if(patient.DEPENDANT > id_max){
            id_max = patient.DEPENDANT;
          }
        }
      )
      let id_new = id_max + 1;
      return {
        ...state,
        patients: {...state.patients, [id_new]: {...action.patient, DEPENDANT: id_new}},
        error: false,
        errors: {},
        loading: false
      };
    case DEMO_PATIENT_REMOVE:
      return {
        ...state,
        patients: delete state.patients[action.patient.DEPENDANT],
        error: false,
        errors: {},
        loading: false
      };
    case DEMO_DEPENDANT_ADD:
      return {
        ...state,
        dependants: [...state.dependants, action.dependant],
        error: false,
        errors: {},
        loading: false
      };
    case DEMO_DEPENDANT_REMOVE:
      return {
        ...state,
        dependants: state.dependants.filter((item) => item !== action.dependant),
        error: false,
        errors: {},
        loading: false
      };
    case DEMO_CLAIM_ITEM_CLEAR:
      return {
        ...state,
        claimItem: {},
        error: false,
        errors: {},
        loading: true
      };
    case DEMO_CLAIM_ITEM_ADD:
      return {
        ...state,
        error: false,
        errors: {},
        loading: true
      };
    case DEMO_CLAIM_ITEM_ADD_SUCCESS:
      return {
        ...state,
        claimItem: INITIAL_STATE.claimItem,
        claimItems: [...state.claimItems, action.data],
        error: false,
        errors: {},
        loading: false
      };
  
    case DEMO_CLAIM_ITEM_REMOVE:
      return {
        ...state,
        claimItems: state.claimItems.filter((item) => item !== action.claimItem),
        error: false,
        errors: {},
        loading: true
      };
    case DEMO_CLAIM_ITEM_REMOVE_SUCCESS:
      return {
        ...state,
        error: false,
        errors: {},
        loading: false
      };
    case DEMO_CLAIM_ITEM_ADD_FAIL:
      return { ...state, error: true, errors: action.errors, loading: false };

    case DEMO_CLAIM_SUBMIT:
      return { ...state, error: false, errors: {}, loading: true};
    case DEMO_CLAIM_SUBMIT_FAIL:
      return { ...state, error: true, errors: action.errors, loading: false};
    case DEMO_CLAIM_SUBMIT_SUCCESS:
      return { ...state, user: {...state.user, ...action.data.user}, claimItems: [], successMessage: action.message, error: false, errors: {}, loading: false};

    case DEMO_CLEAR:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export default reducer;